import React from 'react';
import { IIconProps, sizeMap } from './types';

export const Upload = ({ className, size = 'medium' }: IIconProps) => {
  return (
    <svg
      className={className}
      width={sizeMap[size].width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.55567 7.71597L11.9993 2.84956L16.5427 7.71597M12 2.84956V23M20 1H4"
        stroke="currentcolor"
        strokeWidth={sizeMap[size].strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
